export default __webpack_public_path__ + "static/media/logo.73dd0e12.svg";